import Paragraph from '../typography/Paragraph'

import styles from './styles/Feature.css'
import Header from '../typography/Header'
import Link from '../misc/Link'
import classNames from 'classnames'
import * as analytics from 'lib/analytics'

export const Feature = ({ img = '', imgTop = false, to = '', href = '', header, children, className, ...rest }) => {
  const onFeatureDropdownClick = (header) => {
    analytics.event({
      category: 'Feature Dropdown',
      action: header
    })
  }

  return (
    <Link to={to} href={href} {...rest} onClick={() => onFeatureDropdownClick(header)}>
      <div className={classNames(styles.feature, className)}>
        {imgTop && img && <img className={styles.illo} src={img} alt={header} />}
        <Header className={styles.header} level={6}>
          {!imgTop && img && <img className={styles.illo} src={img} alt={header} />}
          {header}
        </Header>
        <Paragraph light type='bodyLeft' className={styles.featureCopy}>{children}
        </Paragraph>
      </div>
    </Link>
  )
}

export default Feature
